import MainPracticeScenario from './MainPracticeScenario';
import { constants, Globals } from '../../../../misc/helpers';

export default class MainPracticeScenarioSteps12 {
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void, public showFailedAar: () => void) {
	}

	start() {
		this.step1ShowBleedingControlKit();
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the tourniquet.'});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, {
			onSelectionChanged: (index: number) => {
				if (!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
					return;
				}
				if (index === 1) {
					context.step1TourniqueteSelected();
				} else {
					context.step1TourniqueteNotSelected();
				}
			}
		});
	}

	private step1TourniqueteSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.step2ApplySecondTourniquete();
	}
	private step1TourniqueteNotSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	}

	private step2ApplySecondTourniquete() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to apply the second tourniquet above the wound?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps12.step2ApplySecondTourniquete', () => context.step2ApplySecondTourniqueteYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step2ApplySecondTourniqueteNo()
			}
		});
	}

	private step2ApplySecondTourniqueteYes() {
		var context = this;
		context.mainScenario.aarApplySecondTourniquete = true;
		context.step3TourniqueteInteraction();
		this.mainScenario.playSound('Step-11', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-11', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');
			});
		});
	}

	private step2ApplySecondTourniqueteNo() {
		var context = this;
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step2ApplySecondTourniquete());
	}

	private step3TourniqueteInteraction() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the tourniquet to the correct location. KB - Tab to cycle placements, use spacebar to select the location.'});
		this.mainScenario.playSequence('TourniqueteSetup', null, () => {
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				locations: this.mainScenario.locations2,
				correctIndex1: context.mainScenario.correctT2,
				wrongIndex: context.mainScenario.wrongT1,
				closeIndex: context.mainScenario.closeT1,
				isPractice: true,
				isSceneA: context.mainScenario.SceneAT,
				isSceneB: context.mainScenario.SceneBT,
				isSceneC: context.mainScenario.SceneCT,
				isSceneD: context.mainScenario.SceneDT,
				onDone: (selectedNumber: number, isCorrect: boolean) => {
					context.mainScenario.selectedTourniquetIndex = selectedNumber;
					if (isCorrect) {
						context.step3TourniqueteInteractionCorrect();
					} else {
						context.step3TourniqueteInteractionIncorrect();
					}
				}
			});
		});
	}

	private step3TourniqueteInteractionCorrect() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSound('Step-12', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-12', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');
				context.onDone();
			});
		});
		// context.mainScenario.playSequence('Steps12Cinematic', null, () => {
		// 	context.onDone();
		// });
	}
	private step3TourniqueteInteractionIncorrect() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3TourniqueteInteraction());
	}
}